import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import Login from './components/Login';

import DashboardContainer from './layouts/DashboardContainer';
import Dashboard from './components/Dashboard';
import Reports from './components/Reports';
import Benchmarking from './components/Benchmarking';
import Submissions from './components/Submissions';
import EmpClassification from './components/EmpClassification';
import ManageUsers from './components/ManageUsers';
import { Downloads } from './components/Downlaods';

import Help from './components/Help';
import { CensusTasks } from './components/CensusTasks';

import ReportLayout from './components/ReportLayout';
import { BadLink } from './components/Reports/BadLink';
import SpendingReport from './components/Reports/SpendingReport/SpendingReport';

import { UploadDetails } from './components/Submissions/UploadDetails'

import { EmployeeReport } from './components/Reports/EmployeeReport/EmployeeReport';
import NewEmployeeReport from './components/Reports/NewEmployeeReport/NewEmployeeReport';
import EarlyCareerReport from './components/Reports/EarlyCareerReport/EarlyCareerReport';
import Methodology from "./components/Reports/NewEmployeeReport/Methodology"
import { NewVendorReport } from './components/Reports/NewVendorReport/NewVendorReport';
import { NewVendorReport2025 } from './components/Reports/NewVendorReport2025/NewVendorReport2025';
import CTSAReport from './components/Reports/CTSAReport/CTSAReport';
import DetailedDistrictReport from './components/Reports/DetailedDistrictReport/DetailedDistrictReport';
import FactSheet from './components/Reports/FactSheet/FactSheet';

import { connect } from 'react-redux';
import { UserState } from './interface/MyInterfaces';

import BenchmarkingLayout from './components/BenchmarkingLayout';
import BlankLayout from './components/BlankLayout';
import CleanReportLayout from './components/CleanReportLayout';
import ForgotPassword from './components/ForgotPassword';
import PasswordReset from './components/PasswordReset';
import PasswordResetSuccess from './components/PasswordResetSuccess';
import Helmet from "react-helmet";

import AuthContainer from "./layouts/AuthContainer";
import NewEmployeeReportRoutes from './components/Reports/NewEmployeeReport/NewEmployeeReportRoutes';
import EarlyCareerReportRoutes from './components/Reports/EarlyCareerReport/EarlyCareerReportRoutes';

const Title = ({ title }) => {
    return <Helmet>
        <title>{title ? title : "IRIS Portal"}</title>
    </Helmet>
}



const AuthRoute = ({ component: Component, ...rest }) => {
    return (
        <Route {...rest} render={matchProps => (
            <AuthContainer>
                <Component {...matchProps} />
            </AuthContainer>
        )} />
    )
};

const DashboardRoute = ({ component: Component, title, ...rest }) => {
    return (
        <Route {...rest} render={
            (matchProps) =>
            (<DashboardContainer title={title}>
                <Component {...matchProps} />
            </DashboardContainer>)
            }
        />
    )
};


const BenchmarkingLayoutRoute = ({ component: Component, title, ...rest }) => {
    return (
        <Route {...rest} render={matchProps => (
            <BenchmarkingLayout {...matchProps}>
                <Title title={title} />
                <Component {...matchProps} />
            </BenchmarkingLayout>
        )} />
    )
};

const ReportLayoutRoute = ({ component: Component, title, ...rest }) => {
    return (
        <Route {...rest} render={matchProps => (
            <ReportLayout {...matchProps}>
                <Title title={title} />
                <Component {...matchProps} />
            </ReportLayout>
        )} />
    )
};

const CleanReportLayoutRoute = ({ component: Component, title, ...rest }) => {
    return (
        <Route {...rest} render={matchProps => (
            <CleanReportLayout {...matchProps}>
                <Title title={title} />
                <Component {...matchProps} />
            </CleanReportLayout>
        )} />
    )
};

const BlankRoute = ({ component: Component, title, ...rest }) => {
    return (
        <Route {...rest} render={matchProps => (
            <BlankLayout {...matchProps}>
                <Title title={title} />
                <Component {...matchProps} />
            </BlankLayout>
        )} />
    )
};



interface AuthorizationProps {
    UserState?: UserState
}

const Authorization = () =>
    (WrappedComponent) => {
        class WithAuthorization extends React.Component<AuthorizationProps, {}> {
            constructor(props) {
                super(props)
            }
            render() {
                let allowed = false;
                if (this.props.UserState !== undefined && this.props.UserState.isAuthenticated)
                    allowed = true;

                if (allowed) {
                    return <WrappedComponent {...this.props} />
                } else {
                    return <Redirect to='/' />
                }
            }
        }
        function mapStateToProps(state) {
            return { UserState: state.userProperties };
        }
        return connect(mapStateToProps, null)(WithAuthorization);
    }

export const AppRoutes = () => (
    <Switch>
        <AuthRoute exact path='/' component={Login} />
        <AuthRoute path='/forgot-password' component={ForgotPassword} title="Forgot Password" />
        <BlankRoute path='/resetpassword' component={PasswordReset} title="Password Reset" />
        <BlankRoute path='/resetpassword_success' component={PasswordResetSuccess} title="Password Reset Success" />
        <AuthRoute exact path='/Logout' component={Login} />

        <DashboardRoute exact path='/dashboard' component={Authorization()(Dashboard)} title="Dashboard" />
        <DashboardRoute path='/submissions/upload_details/:fileType' component={Authorization()(UploadDetails)} title="File Uploads" />
        <DashboardRoute path='/submissions' component={Authorization()(Submissions)} title="Data File Submissions" />
        <DashboardRoute path='/employee_classification' component={Authorization()(EmpClassification)} styleChange={true} title="Employee Classification" />
        <DashboardRoute path='/manageusers' component={Authorization()(ManageUsers)} title="User Management" />
        <DashboardRoute path='/downloads' component={Authorization()(Downloads)} title="Data Reference Documents" />
        <DashboardRoute path='/help' component={Authorization()(Help)} title="Help and Support" />
        <DashboardRoute path='/censustasks' component={Authorization()(CensusTasks)} title="Census Tasks" />

        <DashboardRoute exact path='/reports' component={Authorization()(Reports)} title="Reports" />
        <DashboardRoute path='/benchmarking' component={Authorization()(Benchmarking)} title="Benchmarking" />

        <DashboardRoute exact path='/reports/factsheet' component={Authorization()(FactSheet)} title="Fact Sheet" />
        <DashboardRoute exact path='/reports/factsheet/:factSheetType' component={Authorization()(FactSheet)} title="Fact Sheet" />

        <ReportLayoutRoute path='/reports/spending_report/:link_id/:p1/:p2/:ne' component={SpendingReport} title="Spending Report" />
        <ReportLayoutRoute path='/reports/spending_report/:link_id/:p1/:p2' component={SpendingReport} title="Spending Report" />
        <ReportLayoutRoute path='/reports/spending_report' component={Authorization()(SpendingReport)} title="Spending Report" />

        <ReportLayoutRoute path='/reports/employee_report/:link_id/:p1/:p2/:ne' component={EmployeeReport} title="Census Supplemental Employee Profile Report" />
        <ReportLayoutRoute path='/reports/employee_report/:link_id/:p1/:p2' component={EmployeeReport} title="Census Supplemental Employee Profile Report" />
        <ReportLayoutRoute path='/reports/employee_report' component={Authorization()(EmployeeReport)} title="Census Supplemental Employee Profile Report" />

        <ReportLayoutRoute path='/reports/new-vendor-report/:link_id/:p1/:p2/:ne' component={NewVendorReport} title="Vendor Profile Report" />
        <ReportLayoutRoute path='/reports/new-vendor-report/:link_id/:p1/:p2' component={NewVendorReport} title="Vendor Profile Report" />
        <ReportLayoutRoute path='/reports/new-vendor-report' component={Authorization()(NewVendorReport)} title="Vendor Profile Report" />

        <ReportLayoutRoute path='/reports/new-vendor-report2025/:link_id/:p1/:p2/:ne' component={NewVendorReport2025} title="Vendor Profile Report" />
        <ReportLayoutRoute path='/reports/new-vendor-report2025/:link_id/:p1/:p2' component={NewVendorReport2025} title="Vendor Profile Report" />
        <ReportLayoutRoute path='/reports/new-vendor-report2025' component={Authorization()(NewVendorReport2025)} title="Vendor Profile Report" />


        <CleanReportLayoutRoute path='/reports/employee-report/:link_id/:p1/:p2/:ne' component={NewEmployeeReportRoutes} title="Employee Profile Report" />
        <CleanReportLayoutRoute path='/reports/employee-report/:link_id/:p1/:p2' component={NewEmployeeReportRoutes} title="Employee Profile Report" />
        <CleanReportLayoutRoute path='/reports/employee-report' component={Authorization()(NewEmployeeReportRoutes)} title="Employee Profile Report" />

        <CleanReportLayoutRoute path='/reports/early-career-report/:link_id/:p1/:p2/:ne' component={EarlyCareerReportRoutes} title="Early Career Profile Report" />
        <CleanReportLayoutRoute path='/reports/early-career-report/:link_id/:p1/:p2' component={EarlyCareerReportRoutes} title="Early Career Profile Report" />
        <CleanReportLayoutRoute path='/reports/early-career-report' component={Authorization()(EarlyCareerReportRoutes)} title="Early Career Profile Report" />

        <ReportLayoutRoute path='/reports/CTSA-Report/:link_id/:p1/:p2' component={CTSAReport} title="CTSA Report" />
        <ReportLayoutRoute path='/reports/CTSA-report' component={Authorization()(CTSAReport)} title="CTSA Report" />

        <ReportLayoutRoute path='/reports/agg-CTSA-Report/:link_id/:p1/:p2' component={CTSAReport} title="Aggregate CTSA Report" />
        <ReportLayoutRoute path='/reports/agg-CTSA-report' component={Authorization()(CTSAReport)} title="Aggregate CTSA Report" />

        <BlankRoute path='/reports/congressional-district-detail-report/:link_id/:p1/:p2' component={DetailedDistrictReport} title="Congressional District Detail Report" />
        <DashboardRoute path='/reports/congressional-district-detail-report' component={Authorization()(DetailedDistrictReport)} title="Congressional District Detail Report" />


        <ReportLayoutRoute path='/reports/bad_link' component={BadLink} title="Not Found" />
    </Switch>
);
